module.exports = __webpack_public_path__ + "img/mickey100.0b97362a.jpg";